import { render } from "./AdproFont.vue?vue&type=template&id=a1f0a3e2"
import script from "./AdproFont.vue?vue&type=script&lang=js"
export * from "./AdproFont.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__